import { Component } from '@angular/core';
import { AssignmentsGridCellActionsModel } from 'src/app/shared/models/assignments-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-assignments-mapping-renderer',
  templateUrl: './assignments-mapping-renderer.component.html',
  styleUrls: ['./assignments-mapping-renderer.component.scss'],
})
export class AssignmentsMappingRendererComponent {
  totalMappings: number = 0;
  params?: AssignmentsGridCellActionsModel;

  // gets called once before the renderer is used
  agInit(params: AssignmentsGridCellActionsModel): void {
    this.totalMappings = params.value;
    this.params = params;
  }

  showMappings() {
    this.params?.onMappingClick(this.params.data);
  }
}
